import { application } from "./application"

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import ConversionProgressController from "./conversion_progress_controller"
application.register("conversion-progress", ConversionProgressController)

import Validator8949Controller from "./validator_8949_controller"
application.register("validator-8949", Validator8949Controller)

import Form8949CodeLookupController from "./form_8949_code_lookup_controller"
application.register("form-8949-code-lookup", Form8949CodeLookupController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
